import 'whatwg-fetch';

export const origin = (document.location && document.location.origin)
  || (`${
    window.location.protocol
  }//${
    window.location.hostname
  }${
    window.location.port ? `:${window.location.port}:` : ''
  }`);

export const isLocalhost = origin.match(/^https?:\/\/localhost/);

export const server = isLocalhost
? `${origin.substring(0, origin.indexOf(':', 7))}:${origin.indexOf('https') === 0 ? 8443 : 8080}`
: origin;

export const Api = `${server}/api`;

export const defaultRequestConfig = Object.freeze({
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: isLocalhost ? 'include' : 'same-origin',
  mode: isLocalhost ? 'cors' : 'same-origin',
  cache: 'default',
});

export const noCacheRequestConfig = Object.freeze({
  ...defaultRequestConfig,
  headers: {
    ...defaultRequestConfig.headers,
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache',
  },
  cache: 'no-store',
});

export const setFhirAuthToken = (token) => {
  if (token === null) {
    delete (defaultRequestConfig.headers['X-Auth']);
  } else {
    defaultRequestConfig.headers['X-Auth'] = `Bearer ${token}`;
  }
};

export const getExtendedRequestConfig = ({ params }) => {
  const config = { ...defaultRequestConfig };
  if (params.method) {
    config.method = params.method;
  }
  if (params.headers) {
    // Make a copy we can safely edit
    config.headers = { ...params.headers };
    Object.keys(params.headers).forEach((key) => {
      const value = params.headers[key];
      if (value === null) {
        delete config.headers[key];
      } else {
        config.headers[key] = value;
      }
    });
  }
  if (config.headers['Content-Type']
  && config.headers['Content-Type'].indexOf('application/json') >= 0
  && params.body) {
    config.body = JSON.stringify(params.body);
  } else {
    config.body = params.body;
  }
  return config;
};

// let checkLogin;

export const handleError = (response) => {
  /*
  if (response.status === 403) {
    if (!checkLogin) {
      checkLogin = fetch(`${Api}/user`, defaultRequestConfig)
      .then((response2) => {
        checkLogin = undefined;
        if (response2.status === 205 || response2.status === 404) {
          // console.log('NOT RELOADING!');
          // document.location.reload();
          return ({ json: () => undefined });
        }
        const error = new Error(response.statusText || response.status);
        error.response = response;
        return Promise.reject(error);
      });
    }
    return checkLogin;
  }
  */

  if (response.status < 200 || response.status >= 300) {
    const error = new Error(response.statusText || response.status);
    error.response = response;
    return Promise.reject(error);
  }

  if (response.status === 205) {
    // TODO: cache something in localstorage?
    // console.log('Session information expired, SHOULD RELOAD!');
    document.location.reload();
    /*
    const error = new Error('Session expired!');
    error.response = response;
    return Promise.reject(error);
    */
  }
  return response;
};

export const getJson = (response) => {
  if (!response.json) {
    const error = new TypeError('No JSON data.');
    error.response = response;
    return Promise.reject(error);
  }
  return response.json();
};

const authenticatedFetch = (url, config) => {
  const { headers } = config;
  const authToken = defaultRequestConfig.headers['X-Auth'];
  if (authToken) {
    headers['X-Auth'] = authToken;
  }
  return fetch(url, {
    ...config,
    headers,
  })
}

export default authenticatedFetch;
